import {
  ExportControlCitizenship,
  IExportControlCitizenship
} from '@precheckin/models/export-control/export-control-citizenship.model';
import {
  ExportControlCountry,
  IExportControlCountry
} from '@precheckin/models/export-control/export-control-country.model';
import { ExportControlStatus } from '@precheckin/models/export-control/export-control-status.enum';
import { cloneDeep } from 'lodash';

export interface IExportControl {
  status: ExportControlStatus;
  updatedAt: string;
  countryOfResidence: IExportControlCountry;
  lastGrantedCitizenship: IExportControlCitizenship;
}

export class ExportControl implements IExportControl {
  status: ExportControlStatus;
  updatedAt: string;
  countryOfResidence: ExportControlCountry;
  lastGrantedCitizenship: ExportControlCitizenship;

  constructor(clone: ExportControl = null) {
    this.status = null;
    this.updatedAt = '';
    this.countryOfResidence = new ExportControlCountry();
    this.lastGrantedCitizenship = new ExportControlCitizenship();

    if (clone) {
      this.status = cloneDeep(clone.status);
      this.updatedAt = cloneDeep(clone.updatedAt);
      this.countryOfResidence = cloneDeep(clone.countryOfResidence);
      this.lastGrantedCitizenship = cloneDeep(clone.lastGrantedCitizenship);
    }
  }
}
